export default "__VITE_ASSET__5kGmG1C3__"